import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type EditCommentsAccountParams = {
  documentoOid: Array<string>;
  comentario: string;
};

export const editCommentsAccountPayment = async (
  query: EditCommentsAccountParams
): Promise<unknown> => {
  try {
    const res = await apiClient.post(
      Endpoints.EditCommentsAccountStatement,
      query
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
